module.exports = __webpack_public_path__ + "img/Boton_inventarios.40943e1f.png";